module.exports = __webpack_public_path__ + "img/fire-extinguisher.a526cad3.svg";